module.exports = __webpack_public_path__ + "img/button_1.92145a8e.png";